export class BaseModel {
    id?: number;
    created_at?: Date;
    updated_at?: Date;
    deleted_at?: Date;
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/base.model.ts